import { Helmet } from "react-helmet-async";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Download } from "@mui/icons-material";
import { APP_TITLE } from "../../constant";
import EmailActivity from "../../modules/EmailActivity/EmailActivity";

const EmailActivityPage = () => {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Email Activity | {APP_TITLE}</title>
        <meta name="description" content="Track and monitor system emails sent to candidates and HRs." />
      </Helmet>

      <Box
        sx={{
          p: 3.5,
          backgroundColor: theme.palette.background.default,
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            mb: 3,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
              Email Activity
            </Typography>
          </Box>
          
        </Box>

        <EmailActivity />
      </Box>
    </>
  );
};

export default EmailActivityPage;
